import angular from "angular"

require("angular-local-storage")
require("angular-toastr")

export interface IUniConfig {
  useLocalStorage: boolean
  urlServiciosProg: string | null
  baseUrl: string
  debug: boolean
}

class UniConfig implements IUniConfig {
  useLocalStorage: boolean
  urlServiciosProg: string | null = null
  baseUrl: string
  debug!: boolean

  constructor($window: ng.IWindowService, $log: ng.ILogService) {
    this.baseUrl = $window.__drac && $window.__drac.ctx
    //  (window as any).__drac && (window as any).__drac.ctx;
    this.useLocalStorage =
      ($window.__drac && $window.__drac.useLocalStorage) || true

    if (!this.baseUrl) {
      $log.warn("baseUrl no definido en la configuración")
    }

    this.debug = $window.__drac && $window.__drac.debug
  }
}

// definición del módulo UniBase
export var unibase_mod = "UniBase"

export var $unibase = angular.module(unibase_mod, [
  "ngResource",
  "LocalStorageModule",
  "toastr"
])

require("./services")
require("./factories")
require("./directivas/unimat-directivas")

// crear el servicio configuración
$unibase.service("UniConfig", ["$window", "$log", UniConfig])
